<core-layout 
  [navItems]="navItems" 
  [logoImagesConfig]="logoConfig" 
  [bottomNavItems]="bottomNavItems">
  <router-outlet></router-outlet>
</core-layout>